import { Flex, IconArrowRight, Link, Text, UnorderedList, Box } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

type SingleCancerDescriptionProps = {
  about: string[];
  cancerGuideUrl: string;
};

export default function SingleCancerDescription({ about, cancerGuideUrl }: SingleCancerDescriptionProps) {
  return (
    <Flex
      bgColor="background-light"
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      direction="column"
    >
      <UnorderedList padding="spacer-6" listStyleType="none">
        {about.map((aboutSentence) => (
          <Flex as="li" key={aboutSentence} pb={4} alignItems="flex-start">
            <Box w="6px" h="6px" bg="text-primary" borderRadius="full" mt="9px" mr="3" flexShrink={0} />
            <Text variant="text-body-regular">{aboutSentence}</Text>
          </Flex>
        ))}
      </UnorderedList>
      <Link
        as={ReactRouterLink}
        to={cancerGuideUrl}
        target="_blank"
        trailingIcon={<IconArrowRight size="xs" />}
        borderTop="1px solid"
        borderColor="ui-element-divider"
        bgColor="background-page"
        borderBottomRadius="radii-3"
        borderTopRadius="none"
        p="3"
        width="100%"
        display="flex"
        justifyContent="center"
      >
        View cancer guide
      </Link>
    </Flex>
  );
}
